export function getBlankRecord() {
  return {
    id: null,
    providerId: null,
    levyCollectionId: null,
    note: "",
    isReminderForNextYear: null
  };
}
